import { render } from "./NameDesc.form.vue?vue&type=template&id=7bf437de"
import script from "./NameDesc.form.vue?vue&type=script&lang=js"
export * from "./NameDesc.form.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'directives', {ClosePopup});
